import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=3ad3c209&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=3ad3c209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3c209",
  null
  
)

export default component.exports